import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { RootState } from 'src/actions/configuration/rootReducer';
import { Portal } from 'src/presentation/components/agent_desktop_components';
import { TOASTS_PORTAL_ID } from '@ad-scripts/presentation/components/toasts/toasts_portal';
import Toast from '@ad-scripts/domain/models/toast';
import Basic from '@ad-scripts/domain/models/toast/content/basic';
import BasicToast from './basicToast';

const Toasts: FC = () => {
  const toastNode = document && document.getElementById(TOASTS_PORTAL_ID);

  const toasts = useSelector((state: RootState) => state.toasts);
  return <Portal node={toastNode}>{_.map(toasts, toast => renderToast(toast))}</Portal>;
};

function renderToast({ type, message, id }) {
  const content = new Basic({ basicType: type, message });
  const toast = new Toast({
    id,
    content,
    type: Toast.Type.BASIC,
    duration: 8000,
    createdAt: new Date().toISOString(),
  });
  return <BasicToast key={id} toast={toast} />;
}
export default Toasts;
